export default __webpack_public_path__ + "static/media/hero-section-art.a1a7bcc7.png";